module.exports = __webpack_public_path__ + "media/shared/assets/fonts/PlusJakartaSans/PlusJakartaSans-Light-f98b4088e49674c8b36ec5193037d2ca.woff2";